import {
    createDataActionFactory,
    Feature,
    hashFolderId,
    createThunk,
    FolderGroupType,
    ThunkDispatch,
} from '../../../shared';
import { exportContactList } from '../../datalayer/exportContactList';
import { saveAs } from 'file-saver';
import { getAppState } from '../../../appstate';
import { splitCsvBytesToLinesOfBytes } from '../../../importcontacts';

export const exportContactsCompletedAction = createDataActionFactory<
    { folderId: string; count: number },
    { folderId: string; groupType: FolderGroupType }
>(
    'ExportContactsCompletedAction',
    Feature.ExportContacts,
    action => ({ folderId: hashFolderId(action.payload.folderId), count: action.payload.count }),
    action => ({
        folderId: hashFolderId(action.payload.folderId),
        groupType: action.payload.groupType,
    })
);

const saveCSVToFile = (csvBytes: Uint8Array, filename: string) =>
    saveAs(new Blob([csvBytes], { type: 'text/csv' }), filename);

export const exportContacts = (fileName: string, folderId?: string) =>
    createThunk('exportContacts', (dispatch: ThunkDispatch, getState: () => {}) => {
        exportContactList(folderId)
            .then(csv => {
                saveCSVToFile(csv, fileName + '.csv');
                const exportedLines = splitCsvBytesToLinesOfBytes(csv);
                const exportedContactsCount = exportedLines.length - 1;
                dispatch(
                    exportContactsCompletedAction.success({
                        folderId,
                        count: exportedContactsCount,
                    })
                );
            })
            .catch(() => {
                const contactFoldersState = getAppState(getState()).data.contactFoldersState;
                const contactFolders = [
                    contactFoldersState.rootContactFolder,
                    contactFoldersState.defaultContactFolder,
                    ...contactFoldersState.displayedContactFolders,
                ];
                const matchingFolder = contactFolders.find(folder => folder.id === folderId);
                dispatch(
                    exportContactsCompletedAction.error({
                        folderId,
                        groupType: matchingFolder?.group,
                    })
                );
            });
    });
export type { DataActionFactory } from '../../../shared';
export type { Action } from '../../../shared';
